@if(xeroTenants.length > 0) {
    <div class="container">
        <p class="mat-h2">Choose Xero Company</p>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Xero Company</mat-label>
            <mat-select [(ngModel)]="currentXeroTenantId">
                @for (item of xeroTenants; track $index) {
                    <mat-option [value]="item.tenantId">
                        {{ item.tenantName }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Xero Export</mat-label>
            <mat-select [(ngModel)]="currentExportId">
                @for (item of xeroExports; track $index) {
                    <mat-option [value]="item.id">
                        {{ item.name }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        @if(xeroInterface.needsDate) {
            <app-ctl-holder [control]="dateField.control"></app-ctl-holder>
        }
        @if (currentExportId && currentXeroTenantId) {
            <div class="button-container">
                <button mat-raised-button color="primary"  [disabled]="working" (click)="getDataFromXero()">
                    @if (working) {
                        Collecting data from Xero...
                    } @else {
                        Get Data from Xero
                    }
                </button>
            </div>
        }

    </div>
} @else {
    <div class="container">
        <p class="mat-h2">Connect to Xero</p>
        <button mat-raised-button color="primary" [disabled]="working" (click)="connectToXero()">
            @if (working) {
                Connecting to Xero
            } @else {
                Connect to Xero
            }
        </button>
    </div>
}
